import { BaseClient } from '@/api'

export class DriverDynamicClient extends BaseClient {
  constructor(
  ) {
    super('driver-dynamics')
  }
}
